import { createSelector } from 'reselect'

export const getItems = createSelector(
  (state) => state.items,
  items => items
);

export const getFilters = createSelector(
  (state) => state.events,
  ({filters}) => filters
);

export const getCount = createSelector(
  (state) => state.events.total_count,
  (total_count) => total_count
);

export const getFiltersSchema = createSelector(
  (state) => state.events,
  ({filtersSchema}) => filtersSchema
);

